export default function ($timeout) {
	"ngInject";
	return {
		restrict: 'AC',
		link: function(_scope, _element) {
			$timeout(function(){
				_element[0].focus();
			}, 0);
		}
	}
}



// WEBPACK FOOTER //
// ./client/app/common/directives/autoFocus.directive.js